export enum LoanProjectionType {
	ONE_TIME = 'oneTimePaymentAmount',
	AUTOPAY = 'autoPayAmount',
	TAKE_BACK = 'takebackAmount',
}
